import React, { useMemo } from 'react';
import { PhoneIncomingIcon, PhoneMissedIcon, PhoneOutgoingIcon } from 'lucide-react';
import { formatDuration } from '../../../utils/format';
import { recentCallsFor } from '../../../utils/userActivity';
import { sourceLabel } from '../../../utils/sources';
import type { Agent, VoiceSource } from '../../../types/voip';
interface DrawerRecentCallsProps {
  agent: Agent;
  source: VoiceSource;
}
export function DrawerRecentCalls({
  agent,
  source
}: DrawerRecentCallsProps) {
  const calls = useMemo(() => recentCallsFor(agent, source), [agent, source]);
  return <section className="p-6" aria-labelledby="drawer-calls-heading" data-id="element-584" data-mp="34l386ldnddqj">
      <h3 id="drawer-calls-heading" className="text-sm font-semibold text-ink" data-id="element-585" data-mp="34j9yex7qmdeb">
        Recent calls
      </h3>
      <p className="text-xs text-muted" data-id="element-586" data-mp="2zkfgryliauvs">Recorded {sourceLabel(source)} calls</p>
      {calls.length === 0 ? <p className="mt-4 text-sm text-muted" data-id="element-587" data-mp="3sb7bssqu5dhj">No recent calls on {sourceLabel(source)}.</p> : <table className="mt-3 w-full text-sm" data-id="element-588" data-mp="22ky6tdzez52c">
          <thead data-id="element-589" data-mp="22l7w0zcmx86z">
            <tr className="text-left text-[11px] text-muted" data-id="element-590" data-mp="22msqyq2v2t5d">
              <th scope="col" className="pb-2 font-medium" data-id="element-591" data-mp="27ird070pvz2m">Time</th>
              <th scope="col" className="pb-2 font-medium" data-id="element-592" data-mp="1sv6bghjhq7wt">Direction</th>
              <th scope="col" className="pb-2 text-right font-medium" data-id="element-593" data-mp="1st25zv5y10uf">Duration</th>
              <th scope="col" className="pb-2 text-right font-medium" data-id="element-594" data-mp="1xs538tfom2ru">Result</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-595" data-mp="1jwktanhxkuwk">
            {calls.map(c => {
          const missed = c.direction === 'missed';
          const outbound = c.direction === 'outbound';
          const Icon = missed ? PhoneMissedIcon : outbound ? PhoneOutgoingIcon : PhoneIncomingIcon;
          return <tr key={c.id} data-id="element-596" data-mp="349jsp3jqnp3v">
                  <td className="whitespace-nowrap py-2.5 pr-3 text-muted" data-id="element-597" data-mp="34bcyyhqfw7bc">{c.time}</td>
                  <td className="py-2.5" data-id="element-598" data-mp="3983hdbppvezx">
                    <span className="flex items-center gap-1.5 text-ink" data-id="element-599" data-mp="39720urpxm0at">
                      <Icon className={`h-3.5 w-3.5 ${missed ? 'text-danger' : 'text-accent'}`} aria-hidden data-id="element-600" data-mp="37tk7jppdrlwb" />
                      {outbound ? 'Outbound' : 'Inbound'}
                    </span>
                    <span className="block truncate text-xs text-muted" data-id="element-601" data-mp="2xul18ds382ch">{c.contact}</span>
                  </td>
                  <td className="py-2.5 text-right text-ink" data-id="element-602" data-mp="2swjg7nb3psyd">{missed ? '—' : formatDuration(c.durationSeconds)}</td>
                  <td className="py-2.5 text-right" data-id="element-603" data-mp="3qkjukldbelmy">
                    <span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ${missed ? 'bg-danger/10 text-danger' : 'bg-positive/10 text-positive'}`} data-id="element-604" data-mp="3lkfaymh41asi">
                      {missed ? 'Missed' : 'Answered'}
                    </span>
                  </td>
                </tr>;
        })}
          </tbody>
        </table>}
    </section>;
}